import React from "react";
import { Dialog } from "./Dialog";
import { Button, ButtonVariant } from "components/common/Button";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  /** Variant applied to the confirm button. Defaults to "primary" for
   * back-compat with every existing ConfirmDialog call site. Use
   * "destructive" when the action is irreversible (delete, leave with
   * data impact, remove member). */
  confirmVariant?: ButtonVariant;
  onConfirm: () => void;
  onCancel: () => void;
  /** × and Escape, when dismissing must differ from the cancel button. */
  onClose?: () => void;
  isLoading?: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "primary",
  onConfirm,
  onCancel,
  onClose = onCancel,
  isLoading = false,
}) => {
  return (
    <Dialog open={open} title={title} onClose={onClose}>
      <div className="mb-6 text-fg-muted-regular">{message}</div>
      <div className="flex justify-end space-x-2">
        <Button variant="secondary" onClick={onCancel} disabled={isLoading}>
          {cancelText}
        </Button>
        <Button
          variant={confirmVariant}
          onClick={onConfirm}
          disabled={isLoading}
        >
          {confirmText}
        </Button>
      </div>
    </Dialog>
  );
};
